import { FC, HTMLProps } from 'react'
import { cn } from '@/lib/utils'

interface ButtonMonthProps extends HTMLProps<HTMLDivElement> {
	isSelected: boolean
}

export const ButtonMonth: FC<ButtonMonthProps> = ({ isSelected, ...rest }) => {
	return (
		<div
			{...rest}
			className={cn(
				'p-3.5 border-2 border-solid rounded-[12px]',
				isSelected ? 'border-[#DCF831]' : 'border-transparent shadow-lg',
				rest.className
			)}>
			<p className={'text-[13px] text-[#4D4F50]'}>Ежемесячный</p>
			<p className={'font-bold text-[22px] '}>640.00 ₽</p>
			<p className={'text-[12px] text-[#4D4F50]'}>В месяц</p>
		</div>
	)
}
